<template>
		<div class="content wrap-page" style="padding-top:20px">
		<Header></Header>
			<div class="info crfff">
        <div class="back" @click="back" style="">
          <img width="50" src="../../static/images/back.png" />
        </div>
        <div class="fs50 w-title mt20 ac">{{$t('rankList')}}</div>
        <div class="rank-list mt30">
          <div v-if="redeemList && redeemList.length === 0" class="empty-message ac">
            {{$t('NoRankList')}}
          </div>
          <div class="li" v-for="(item,index) in redeemList" v-else>
            <div class="li-t disflex">
              <div class="lf" :class="'lf'+index">
                <div class="disflex">
                  <img style="width: 135px; height: 135px;border-radius: 100%" :src="item.avatar" />
                  <div class="">
                    <div class="title">{{item.nickname}}</div>
                    <div class="prz">{{item.mobile}}</div>
                  </div>
                </div>
              </div>
              <div class="rf">
                <div class="disflex">
                  <div class="pt-font">
                    <div class="disflex">
                      <img src="../../static/images/pt-icon.png" />
                      <div class="disflex">{{item.points}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cpon ac" style="margin-top: 5px">{{item.tip}}</div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/HeaderTwo'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:null
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {
		back(){
			this.$router.go(-1);
      // this.$router.push({path:'/land',query: {msisdn:this.$route.query.mobile}});
		},
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/ranking',null,r =>{
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
	}
}
</script>
<style>
.empty-message {
  padding: 100px 0;
  font-size: 24px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/page/rankList.vue